angular.module('admin.directives')

  .directive('agentBilling', [function(){
    return {
      restrict: 'A',
      controllerAs: 'agentBillingCtrl',
      bindToController: {
        agent: '=',
      },
      scope: {},
      controller: angular.noop,
      templateUrl: '/admin/templates/agent-billing.html',
    }

  }]);
